import { isEqual } from "lodash";
import { useMemo } from "react";
import { useForm, useFormState } from "react-final-form";
import PendingChangesBar from "../../common/PendingChangesBar";

const isEmpty = (v) => v === undefined || v === null || v === "";

const computeChangedPaths = (values, initial) => {
  const out = [];
  const walk = (cur, init, prefix) => {
    const keys = new Set([
      ...Object.keys(cur || {}),
      ...Object.keys(init || {}),
    ]);
    for (const k of keys) {
      const path = prefix ? `${prefix}.${k}` : k;
      const cv = cur?.[k];
      const iv = init?.[k];
      if (isEmpty(cv) && isEmpty(iv)) continue;
      if (
        cv &&
        typeof cv === "object" &&
        !Array.isArray(cv) &&
        !(cv instanceof Date)
      ) {
        walk(cv, iv || {}, path);
      } else if (!isEqual(cv, iv)) {
        out.push(path);
      }
    }
  };
  walk(values || {}, initial || {}, "");
  return out;
};

const RffPendingChangesBanner = ({
  initialValues,
  getFieldLabel,
  formatField,
  loading,
}) => {
  const { values, submitting } = useFormState({
    subscription: { values: true, submitting: true },
  });
  const form = useForm();

  const changedPaths = useMemo(
    () => computeChangedPaths(values, initialValues),
    [values, initialValues],
  );
  const count = changedPaths.length;



  const handleDiscard = () => {
    form.reset(initialValues);
  };

  const handleSave = () => {
    form.submit();
  };

  const isSaving = submitting || loading;

  // The floating pill (the same one Loan Info's unified save uses), placed
  // inside the sidebar panel so it slides up from the panel's bottom edge.
  return (
    <PendingChangesBar
      placement="container"
      dirty={count > 0}
      saving={isSaving}
      count={count}
      onSave={handleSave}
      onDiscard={handleDiscard}
    />
  );
};

export default RffPendingChangesBanner;
